<template>
	<v-card style="min-height: 250px;">
		<v-toolbar flat color="primary" dark>
			<v-toolbar-title>Establecer medio</v-toolbar-title>
		</v-toolbar>
		<v-tabs vertical color="deep-purple accent-4">
			<v-tab>
				<v-icon left>mdi-image-outline</v-icon>
				Imagen
			</v-tab>
			<!--<v-tab>
				<v-icon left>mdi-movie-open</v-icon>
				Video
			</v-tab>-->

			<v-tab-item>
				<v-card flat>
						<v-card-title>Sube una imagen desde tu computador:</v-card-title>
						<v-card-text>
							<subir-archivo
								v-model="value.ubicación"
								label="Selecciona una imagen"
								prepend-icon="mdi-image"
								accept="image/*"
								@input="deseleccionarImagen()"
							></subir-archivo>
						</v-card-text>
						<v-card-title>O pega la dirección URL de una imagen:</v-card-title>
						<v-card-text>
							<v-text-field
								v-model="value.ubicación"
								label="Direccion URL de la imagen"
								placeholder="Pega aquí el enlace de la imagen"
								outlined
								type="url"
								aaaaaaaautofocus
								full-width
							></v-text-field>
						</v-card-text>
						<v-card-title>O selecciona una imagen de tu galería:</v-card-title>
						<v-card-text>
							<v-tooltip  v-for="archivo in archivos.listadoImágenes" :key="archivo.identificador" bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-hover v-slot:default="{ hover }">
										<v-card
											max-width="100"
											style="display: inline-block; margin: 5px"
											v-bind="attrs"
											v-on="on"
											:elevation="hover ? 12 : 2"
											:class="{ 'miniatura': true, 'on-hover': hover, 'seleccionada': imagenSeleccionada.identificador === archivo.identificador }"
											@click="seleccionarImagen(archivo)"
											:tile="imagenSeleccionada.identificador === archivo.identificador"
										>
											<v-img :src="archivo.datos.imagen.miniatura" height="100px"></v-img>
										</v-card>
									</v-hover>
								</template>
								<span>{{ nombreDeArchivoDesdeStorage(archivo.datos.ubicación) }}</span>
							</v-tooltip>
						</v-card-text>
						<!--<v-tabs>
							<v-tab>
								Subir una imagen
							</v-tab>
							<v-tab>
								Desde una dirección URL
							</v-tab>
							<v-tab-item class="py-8 pr-8">
								dfdkfdk
							</v-tab-item>
							<v-tab-item class="py-8 pr-8">
								<v-text-field
									v-model="value.ubicación"
									label="Direccion URL de la imagen"
									placeholder="Pega aquí el enlace de la imagen"
									outlined
									type="url"
									autofocus
									full-width
								></v-text-field>
							</v-tab-item>
						</v-tabs>-->
				</v-card>
			</v-tab-item>
			<!--<v-tab-item>
				<v-card flat>
					<v-card-text>
						<p>
							Fusce a quam. Phasellus nec sem in justo pellentesque facilisis. Nam eget dui. Proin viverra, ligula sit amet ultrices semper, ligula arcu tristique sapien, a accumsan nisi mauris ac eros. In dui magna, posuere eget, vestibulum et, tempor auctor, justo.
						</p>

						<p class="mb-0">
							Cras sagittis. Phasellus nec sem in justo pellentesque facilisis. Proin sapien ipsum, porta a, auctor quis, euismod ut, mi. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nam at tortor in tellus interdum sagittis.
						</p>
					</v-card-text>
				</v-card>
			</v-tab-item>-->
		</v-tabs>

		<v-divider></v-divider>

		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn
				color="primary"
				text
				@click="$emit('hecho', true)"
			>
				Cerrar
			</v-btn>
		</v-card-actions>

	</v-card>
</template>

<script>
import SubirArchivo from '@/components/utilidades/SubirArchivo'
import { nombreDeArchivoDesdeStorage } from '@/utilidades.js'
import { archivos } from '@/fuentes.js'

export default {
	name: 'SeleccionarMedio',

	data: () => ({
		archivos: archivos,
		imagenSeleccionada: {
			identificador: '',
			ubicación: '',
		}
	}),

	components: {
		SubirArchivo
	},

	props: {
		value: {
			type: Object,
			default: function () {
				return {
					tipo: 'imagen',
					ubicación: ''
				}
			}
		}
	},

	watch: {
		value: {
			handler(val){
				this.$emit('input', this.value)
			},
			deep: true
		}
	},

	mounted: function() {
		this.archivos.inicializar()
	},

	methods: {
		nombreDeArchivoDesdeStorage,
		seleccionarImagen: function(dts) {
			this.imagenSeleccionada.identificador = dts.identificador
			this.imagenSeleccionada.ubicación = dts.datos.ubicación
			this.value.ubicación = dts.datos.ubicación
		},
		deseleccionarImagen: function() {
			this.imagenSeleccionada.identificador = ''
			this.imagenSeleccionada.ubicación = ''
		}
	}
}
</script>

<style scoped>

.v-card.miniatura:not(.on-hover):not(.seleccionada) {
  opacity: 0.8;
 }

 .seleccionada {
	 border: 3px solid green;
 }

</style>